"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var handlers_exports = {};
__export(handlers_exports, {
  summaryHandlers: () => summaryHandlers
});
module.exports = __toCommonJS(handlers_exports);
function summaryHandlers() {
  const headings = [];
  const linkHrefs = [];
  const imageUrls = [];
  let currentHeading = void 0;
  return {
    text(str) {
      if (currentHeading != null) {
        currentHeading = { ...currentHeading, text: currentHeading.text + str };
      }
    },
    softBreak() {
    },
    lineBreak() {
    },
    htmlInline(_html) {
    },
    code(_text) {
    },
    thematicBreak() {
    },
    codeBlock(_info, _code) {
    },
    htmlBlock(_html) {
    },
    customInline(_text) {
    },
    customBlock(_text) {
    },
    openEmph() {
    },
    closeEmph() {
    },
    openStrong() {
    },
    closeStrong() {
    },
    openLink(href) {
      linkHrefs.push(href);
    },
    closeLink() {
    },
    openImage(src) {
      imageUrls.push(src);
    },
    closeImage() {
    },
    openDocument() {
    },
    closeDocument() {
    },
    openParagraph() {
    },
    closeParagraph() {
    },
    openBlockQuote() {
    },
    closeBlockQuote() {
    },
    openItem() {
    },
    closeItem() {
    },
    openList(_type, _delimiter, _start, _tight) {
    },
    closeList() {
    },
    openHeading(level) {
      currentHeading = { level, text: "" };
    },
    closeHeading() {
      if (currentHeading != null) {
        headings.push(currentHeading);
        currentHeading = void 0;
      }
    },
    result() {
      return {
        headings,
        linkHrefs,
        imageUrls
      };
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  summaryHandlers
});
//# sourceMappingURL=handlers.js.map
